import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useSession } from 'session/src/hooks/useSession'
import useSWRMutation from 'swr/mutation'
import { env } from 'utils/envManager'

import { chatbotMessagePulling } from '../services/chatbotMessagePulling'

const baseUrl = '/v1/dispatcher/messagePulling'
const endpoint = new URL(baseUrl, env.NEXT_PUBLIC_IRIS_DOMAIN)

export const useChatbotMessagePulling = () => {
	const {
		country: { countryISO, languageISO },
	} = useMasterData()
	const { token } = useSession()

	const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

	const fetcher = (
		url: URL,
		{
			arg: { chatbotSessionId },
		}: {
			arg: {
				chatbotSessionId: string | null
			}
		}
	) =>
		chatbotMessagePulling(url, {
			countryISO,
			token,
			languageISO,
			timeZone,
			sessionId: chatbotSessionId,
		})

	const { trigger } = useSWRMutation(endpoint, fetcher)

	return {
		triggerChatbotMessagePulling: trigger,
	}
}
